import React, { useState, useCallback, useEffect } from 'react'
import ReactFlow, { 
  Background,
  Controls,
  ConnectionMode,
  MarkerType,
  applyNodeChanges,
  applyEdgeChanges
} from 'reactflow'
import 'reactflow/dist/base.css'
import { Text } from '@ui5/webcomponents-react';
import { useNavigate } from 'react-router-dom';

// Componentes rediseñados con estilo profesional
const PurchaseOrderNode = ({ orderNumber, deliveryDate, isSelected, onClick }) => (
  <div 
    style={{ 
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: isSelected ? '0 8px 25px rgba(59, 130, 246, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
      border: isSelected ? '2px solid #3b82f6' : '1px solid #e5e7eb',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      width: '220px',
      overflow: 'hidden'
    }}
    onClick={onClick}
  >
    <div style={{ 
      background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
      padding: '12px 16px',
      borderRadius: '12px 12px 0 0'
    }}>
      <Text style={{ 
        fontWeight: '600', 
        fontSize: '14px', 
        color: 'white',
        letterSpacing: '0.5px'
      }}>
        ORDEN DE COMPRA
      </Text>
    </div>
    <div style={{ 
      backgroundColor: 'white',
      padding: '16px',
      borderRadius: '0 0 12px 12px'
    }}>
      <Text style={{ 
        color: '#1f2937', 
        fontSize: '16px', 
        fontWeight: '700',
        marginBottom: '4px'
      }}>
        Nro. {orderNumber}
      </Text>
      <Text style={{ 
        color: '#6b7280', 
        fontSize: '12px',
        fontWeight: '500'
      }}>
        {deliveryDate}
      </Text>
    </div>
  </div>
);

const AsnNode = ({ id, number, date, status, isSelected, onClick, clickable = true }) => {
  if (!id) {
    console.warn("NodoNotificación renderizado sin ID:", { number, date });
  }
  
  // Función para obtener el color del estado
  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending': return '#f59e0b';
      case 'Shipped': return '#3b82f6';
      case 'Received': return '#10b981';
      case 'Approved': return '#059669';
      case 'Canceled': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'Pending': return 'Creada';
      case 'Shipped': return 'Despachada';
      case 'Received': return 'Recepcionada';
      case 'Approved': return 'Finalizada';
      case 'Canceled': return 'Anulada';
      default: return status || 'Sin estado';
    }
  };

  return (
    <div 
      style={{ 
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: isSelected ? '0 8px 25px rgba(16, 185, 129, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
        border: isSelected ? '2px solid #10b981' : '1px solid #e5e7eb',
        cursor: clickable ? 'pointer' : 'default',
        opacity: clickable ? 1 : 0.7,
        transition: 'all 0.3s ease',
        width: '200px',
        overflow: 'hidden'
      }}
      onClick={() => {
        if (!clickable) {
          console.warn("Usuario sin permisos para ver notificaciones");
          return;
        }
        if (!id) {
          console.error("Intento de click en notificación sin ID");
          return;
        }
        console.log("Click en NodoNotificación con ID:", id);
        onClick(id);
      }}
    >
      <div style={{ 
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        padding: '12px 16px',
        borderRadius: '12px 12px 0 0'
      }}>
        <Text style={{ 
          fontWeight: '600', 
          fontSize: '14px', 
          color: 'white',
          letterSpacing: '0.5px'
        }}>
          NOTIFICACIÓN
        </Text>
      </div>
      <div style={{ 
        backgroundColor: 'white',
        padding: '16px',
        borderRadius: '0 0 12px 12px'
      }}>
        <Text style={{ 
          color: '#1f2937', 
          fontSize: '16px', 
          fontWeight: '700',
          marginBottom: '8px'
        }}>
          Nro. {number}
        </Text>
        <Text style={{ 
          color: '#6b7280', 
          fontSize: '12px',
          fontWeight: '500',
          marginBottom: '8px'
        }}>
          {date}
        </Text>
        <div style={{
          backgroundColor: getStatusColor(status),
          color: 'white',
          padding: '4px 8px',
          borderRadius: '6px',
          fontSize: '11px',
          fontWeight: '600',
          textAlign: 'center',
          textTransform: 'uppercase'
        }}>
          {getStatusLabel(status)}
        </div>
      </div>
    </div>
  );
};

const PackageNode = ({ number, weight, dimensions, isSelected, onClick }) => (
  <div 
    style={{ 
      backgroundColor: 'white',
      borderRadius: '10px',
      boxShadow: isSelected ? '0 6px 20px rgba(249, 115, 22, 0.3)' : '0 3px 10px rgba(0, 0, 0, 0.08)',
      border: isSelected ? '2px solid #f97316' : '1px solid #e5e7eb',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      width: '160px',
      overflow: 'hidden'
    }}
    onClick={onClick}
  >
    <div style={{ 
      background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
      padding: '10px 12px',
      borderRadius: '10px 10px 0 0'
    }}>
      <Text style={{ 
        fontWeight: '600', 
        fontSize: '12px', 
        color: 'white',
        letterSpacing: '0.5px'
      }}>
        BULTO
      </Text>
    </div>
    <div style={{ 
      backgroundColor: 'white',
      padding: '12px',
      borderRadius: '0 0 10px 10px'
    }}>
      <Text style={{ 
        color: '#1f2937', 
        fontSize: '14px', 
        fontWeight: '700',
        marginBottom: '4px'
      }}>
        Nro. {number}
      </Text>
      {weight && (
        <Text style={{ 
          color: '#6b7280', 
          fontSize: '10px',
          fontWeight: '500',
          marginBottom: '2px'
        }}>
          {weight} kg
        </Text>
      )}
      {dimensions && (
        <Text style={{ 
          color: '#6b7280', 
          fontSize: '9px',
          fontWeight: '400',
          lineHeight: '1.2'
        }}>
          {dimensions}
        </Text>
      )}
    </div>
  </div>
);

const createNodeData = (Component, props) => ({
  label: <Component {...props} />
});

export default function FlowDiagram({ id, asns = [], deliveryDate }) {
  console.log("FlowDiagram received asns:", asns);

  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [packageCount, setPackageCount] = useState(0);
  const navigate = useNavigate();

  const handleNodeClick = (nodeId) => {
    setSelectedNodeId(nodeId);
  };

  const handleAsnClick = (asnId) => {
    console.log("handleAsnClick called with asnId:", asnId);
    navigate(`/asn/${asnId}`);
  };

  useEffect(() => {
    console.log("Creating nodes with asns:", asns);

    let currentY = 100; // Starting Y position for the first node

    // Nodo de Orden de Compra
    const orderNode = {
      id: 'orden',
      type: 'default',
      position: { x: 50, y: currentY },
      data: createNodeData(PurchaseOrderNode, {
        orderNumber: id,
        deliveryDate: deliveryDate,
        isSelected: selectedNodeId === 'orden',
        onClick: () => handleNodeClick('orden')
      }),
      style: {
        background: 'transparent',
        border: 'none',
        width: 220,
        height: 120,
      },
      draggable: false,
      connectable: false
    };

    const allNodes = [orderNode];
    const initialEdges = [];

    // Adjust currentY for the next set of nodes
    currentY += 150; // Add some vertical space after the order node

    // Crear nodos para TODOS los ASNs
    const asnNodes = asns.map((asn) => {
      console.log("Creando nodo para ASN:", asn);
      if (!asn.id) {
        console.warn("ASN sin ID detectado:", asn);
      }
      
      const asnNode = {
        id: `asn-${asn.id}`,
        type: 'default',
        position: { x: 350, y: currentY },
        data: createNodeData(AsnNode, {
          id: asn.id,
          number: asn.number || 'N/A',
          date: asn.date || 'N/A',
          status: asn.status || 'Pending',
          isSelected: selectedNodeId === `asn-${asn.id}`,
          clickable: asn.clickable !== undefined ? asn.clickable : true,
          onClick: () => {
            console.log("Click en Notificación con ID:", asn.id);
            if (typeof asn.onClick === 'function') {
              asn.onClick(asn.id);
            } else {
              handleAsnClick(asn.id);
            }
          }
        }),
        style: {
          background: 'transparent',
          border: 'none',
          width: 200,
          height: 160,
        },
        draggable: false,
        connectable: false
      };

      allNodes.push(asnNode);

      // Conexión de Orden a ASN
      initialEdges.push({
        id: `orden-${asnNode.id}`,
        source: 'orden',
        target: asnNode.id,
        type: 'straight',
        style: {
          stroke: '#64748b',
          strokeWidth: 2
        },
        markerEnd: {
          type: MarkerType.ArrowClosed,
          color: '#64748b',
          width: 20,
          height: 20
        },
      });

      // Actualizar currentY para los bultos o el siguiente ASN
      let packageY = currentY + 120; // Starting Y for packages relative to ASN

      if (asn.packages && asn.packages.length > 0) {
        asn.packages.forEach((pkg, pkgIndex) => {
          const packageNode = {
            id: `bulto-${asn.id}-${pkgIndex}`,
            type: 'default',
            position: { x: 650, y: packageY },
            data: createNodeData(PackageNode, {
              number: pkg.number,
              weight: pkg.weight,
              dimensions: pkg.dimensions,
              isSelected: selectedNodeId === `bulto-${asn.id}-${pkgIndex}`,
              onClick: () => handleNodeClick(`bulto-${asn.id}-${pkgIndex}`)
            }),
            style: {
              background: 'transparent',
              border: 'none',
              width: 160,
              height: 90,
            },
            draggable: false,
            connectable: false
          };

          allNodes.push(packageNode);

          // Conexión de ASN a Bulto
          initialEdges.push({
            id: `asn-${asn.id}-${packageNode.id}`,
            source: asnNode.id,
            target: packageNode.id,
            type: 'straight',
            style: {
              stroke: '#64748b',
              strokeWidth: 2
            },
            markerEnd: {
              type: MarkerType.ArrowClosed,
              color: '#64748b',
              width: 20,
              height: 20
            },
          });

          packageY += 100; // Increment Y for the next package
        });
        currentY = packageY; // Update currentY to the last package's Y + some padding
      } else {
        currentY += 160; // If no packages, just add ASN node height
      }
      currentY += 50; // Add some padding between ASNs or between ASN and next ASN/package group

      return asnNode; // Return asnNode for the .map function (though not strictly used)
    });

    setNodes(allNodes);

    // Calcular total de bultos de todos los ASNs
    const totalPackages = asns.reduce((total, asn) => total + (asn.packages?.length || 0), 0);
    setPackageCount(totalPackages);

    setEdges(initialEdges);
  }, [asns, id, deliveryDate, selectedNodeId]);

  const onNodesChange = useCallback(
    (changes) => {
      setNodes((nds) => applyNodeChanges(changes, nds));
      const selectChange = changes.find(change => change.type === 'select');
      if (selectChange) {
        setSelectedNodeId(selectChange.selected ? selectChange.id : null);
      }
    },
    []
  );

  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    []
  );

  return (
    <div style={{ 
      width: '100%',
      height: '500px',
      backgroundColor: '#f8fafc',
      borderRadius: '12px',
      border: '1px solid #e2e8f0',
      overflow: 'hidden',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
    }}>
      <div style={{
        padding: '16px 20px',
        backgroundColor: 'white',
        borderBottom: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div>
          <Text style={{ 
            fontSize: '18px', 
            fontWeight: '700', 
            color: '#1f2937',
            marginBottom: '4px'
          }}>
            Flujo de notificación
          </Text>
          <Text style={{ 
            fontSize: '14px', 
            color: '#6b7280',
            fontWeight: '500'
          }}>
            Orden de compra → Notificación ASN → Bultos
          </Text>
        </div>
        <div style={{
          backgroundColor: '#f3f4f6',
          padding: '8px 12px',
          borderRadius: '6px',
          border: '1px solid #d1d5db'
        }}>
                     <Text style={{ 
             fontSize: '12px', 
             color: '#374151',
             fontWeight: '600'
           }}>
             {packageCount} Bultos
           </Text>
        </div>
      </div>
      
      <div style={{ height: 'calc(100% - 80px)' }}>
        <ReactFlow 
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          connectionMode={ConnectionMode.Loose}
          fitView
          fitViewOptions={{
            padding: 0.3,
            includeHiddenNodes: false,
            minZoom: 0.4,
            maxZoom: 1.2
          }}
          minZoom={0.4}
          maxZoom={1.5}
          defaultZoom={0.7}
          style={{
            backgroundColor: '#f8fafc'
          }}
          panOnScroll
          panOnScrollSpeed={0.5}
          zoomOnScroll={false}
          zoomOnPinch
          preventScrolling={false}
        >
          <Background 
            color="#e2e8f0"
            gap={20}
            size={1}
            variant="dots"
          />
          <Controls 
            style={{
              bottom: 10,
              left: 10
            }}
            showZoom={true}
            showFitView={true}
            showInteractive={false}
          />
        </ReactFlow>
      </div>
    </div>
  );
}